import Page from "webPage/Page";

Page.register('page-id-97', () => {
    $('body').on('click', '.js-cookie-modal', function(){
        let modalId = $(this).attr('data-id');
        $('.js-cookie-modal[data-id="' + modalId + '"]').addClass('modal--active');
        $('body').addClass('modal-active');
        return false;
    }).on('click', '.js-close-modal', function(){
        $(this).closest('.js-cookie-modal').removeClass('modal--active');
        $('body').removeClass('modal-active');
        return false;
    })
});
